module.exports = __webpack_public_path__ + "img/SAFo_KeyTakeAways_SocialMedia.de8cbf5c.svg";